export default {
  head_scripts: {
    title: 'Head Scripts',
  },
  body_noscripts: {
    title: 'Body noscripts',
    description: 'Code direct na de openende body-tag invoegen',
  },
  google_site_verification: {
    title: 'Google Site Verification',
    label: 'Google Site Verification-code',
  },
  buttons: {
    save: 'Opslaan',
  },
};
